import { getUrls } from "utils/urls";
import useApiWrapper from "./useApiWrapper";

const useWSMApi = () => {
  const { fetchWithAuth } = useApiWrapper();
  const URLS = getUrls();

  const sendLoginOTP = async (data: any) => {
    return await fetchWithAuth(URLS.SEND_OTP, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  };

  const validateLoginOTP = async (data: any) => {
    return await fetchWithAuth(URLS.VALIDATE_OTP, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  };

  const fetchUserProfile = async () => {
    return await fetchWithAuth(URLS.GET_PROFILE, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchWSMSlots = async (data: any) => {
    const queryParams = new URLSearchParams(data).toString();
    return await fetchWithAuth(`${URLS.GET_WSM_SLOTS}?${queryParams}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchReservations = async (slotId: string) => {
    return await fetchWithAuth(URLS.GET_RESERVATIONS(slotId), {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchExclusiveSlot = async () => {
    return await fetchWithAuth(URLS.GET_EXCLUSIVE_SLOT, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const reservationCheckIn = async (data: any) => {
    const queryParams = new URLSearchParams(data).toString();
    return await fetchWithAuth(`${URLS.RESERVATION_CHECK_IN}?${queryParams}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
    });
  };

  return {
    sendLoginOTP,
    validateLoginOTP,
    fetchUserProfile,
    fetchWSMSlots,
    fetchReservations,
    fetchExclusiveSlot,
    reservationCheckIn,
  };
};

export default useWSMApi;
